import {
  Button,
  NavBar,
  Row,
  Col,
  Tag,
  Icon,
  Cell,
  CellGroup,
  Panel,
  Dialog,
  Swipe,
  Toast,
  SwipeItem,
  SubmitBar,
  Tabbar, TabbarItem,
  GoodsAction,
  GoodsActionBigBtn,
  GoodsActionMiniBtn,
  AddressEdit,
  Slider,
  Stepper,
  Steps,
  Pagination,
  Area
} from 'vant';

// app
import KBlock from './app/k-block'
import KNavbar from './app/k-navbar'
import KTabbar from './app/k-tabbar'
import KNumRate from './app/k-num-rate'
import KNumMoney from './app/k-num-money'
import KNumRank from './app/k-num-rank'
import KNumScore from './app/k-num-score'
import KTxtRank from './app/k-txt-rank'
import KTxtTime from './app/k-txt-time'
import KTxtAdvance from './app/k-txt-advance'


import KTableActions from './app/k-table-actions'
import KPagination from './app/k-pagination'
import KUser from './app/k-user'

import TxtVipAudio from './txt/txt-vip-audio'
import TxtWaitRes from './txt/txt-wait-res'
import TxtLoading from './txt/txt-loading'
import TxtNoData from './txt/txt-no-data'

import AdVipAudio from './ad/ad-vip-audio'

// chart
import EChart from './kchart/e-chart'
import KCandle from './kchart/k-candle'
import KVolume from './kchart/k-volume'
import KKdj from './kchart/k-kdj'
import KMacd from './kchart/k-macd'

// match
import SectStatus from './match/stage/index'

// reality
import RCupBar from './reality/r-cup-bar'

export default (Vue) => {
  function register(O) {
    for (const name in O) {
      if (O.hasOwnProperty(name)) {
        Vue.component(name, O[name])
      }
    }
  }
  register({
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Toast.name]: Toast,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Dialog.name]: Dialog,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionBigBtn.name]: GoodsActionBigBtn,
    [GoodsActionMiniBtn.name]: GoodsActionMiniBtn,
    [SubmitBar.name]: SubmitBar,
    [NavBar.name]: NavBar,
    [Panel.name]: Panel,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Slider.name]: Slider,
    [Stepper.name]: Stepper,
    [Steps.name]: Steps,
    [Pagination.name] : Pagination,
    [Area.name]: Area,
    [AddressEdit.name]: AddressEdit,
    // [VeLine.name] : VeLine,
    // [VeCandle.name]: VeCandle,

    [EChart.name] : EChart,
    [KCandle.name]: KCandle,
    [KVolume.name]: KVolume,
    [KKdj.name]: KKdj,
    [KMacd.name]: KMacd,
    [KPagination.name]: KPagination,
    [KNumRank.name]: KNumRank,
    [KTxtRank.name]: KTxtRank,
    [KTxtTime.name]: KTxtTime,
    [KTxtAdvance.name]: KTxtAdvance,

    [KBlock.name]: KBlock,
    [KUser.name]: KUser,
    [KNavbar.name]: KNavbar,
    [KTabbar.name]: KTabbar,
    [KNumRate.name]: KNumRate,
    [KNumMoney.name]: KNumMoney,
    [KTableActions.name]: KTableActions,
    [KNumScore.name]: KNumScore,

    [TxtVipAudio.name]: TxtVipAudio,
    [TxtWaitRes.name]: TxtWaitRes,
    [TxtLoading.name]: TxtLoading,
    [TxtNoData.name]: TxtNoData,

    [AdVipAudio.name]: AdVipAudio,

    [RCupBar.name]: RCupBar,

    'sect-status': SectStatus
  })
  // Vue.component(NavBar.name, NavBar)
  // Vue.component(Row.name, Row)
  // Vue.component(Col.name, Col)
  // Vue.component(Tag.name, Tag)
  // Vue.component(Icon.name, Icon)
  // Vue.component(Toast.name, Toast)
  // Vue.component(Cell.name, Cell)
  // Vue.component(CellGroup.name, CellGroup)
  // Vue.component(Swipe.name, Swipe)
  // Vue.component(SwipeItem.name, SwipeItem)
  // Vue.component(SwipeItem.name, SwipeItem)
  // Vue.component(Dialog.name, Dialog)

  // Vue.component(GoodsAction.name, GoodsAction)
  // Vue.component(GoodsActionBigBtn.name, GoodsActionBigBtn)
  // Vue.component(GoodsActionMiniBtn.name, GoodsActionMiniBtn)
  // Vue.component(SubmitBar.name, SubmitBar)

  // Vue.component('img-user-stage', ImgUserStage)
  // Vue.component('timer-text', TimerText)
  // Vue.component('wz-navbar', WzNavbar)
  // Vue.component('timer-num', TimerNum)
  // Vue.component('goods-button-buy', ButtonBuy)
  // Vue.component('detail-head-timer', DetailHeadTimer)
  // Vue.component('goods-404', Goods404)
  // Vue.component('goods-top', GoodsTop)
  // Vue.component('rule-text', RuleText)

  // Vue.component('goods-status', GoodsStatus) // 商品状态
  // Vue.component('goods-pre-status', GoodsPreStatus) // 预售商品状态
  // Vue.component('goods-last-status', GoodsLastStatus) // 尾款商品状态
  // Vue.component('qr-code', QRCode)

  // Vue.component('detail-head', DetailHead)
  // Vue.component('detail-body-pre', DetailBodyPre)
  // Vue.component('detail-body-last', DetailBodyLast)
  // Vue.component('goods-item-big', GoodsItemBig)



  // Vue.component('goods-item-11', GoodsItem11)
  // Vue.component('goods-item-12', GoodsItem12)
  // Vue.component('goods-item-2x', GoodsItem2x)

  // 商品详情
  // Vue.component('goods-11', Goods11)
  // Vue.component('goods-12', Goods12)
  // Vue.component('goods-21', Goods21)
  // Vue.component('goods-22', Goods22)
  // Vue.component('goods-23', Goods23)
}
